import { useMemo } from 'react';
import { useUIStore } from '@/store';

/**
 * Toast Hook
 *
 * Simplified interface for showing toast notifications
 */
export const useToast = () => {
  const { addToast } = useUIStore();

  const api = useMemo(
    () => ({
      success: (message: string, duration?: number) =>
        addToast({ type: 'success', message, duration }),

      error: (message: string, duration?: number) => addToast({ type: 'error', message, duration }),

      warning: (message: string, duration?: number) =>
        addToast({ type: 'warning', message, duration }),

      info: (message: string, duration?: number) => addToast({ type: 'info', message, duration }),
    }),
    [addToast]
  );

  return api;
};
